export default "__VITE_ASSET__CWmqwkWE__"